import React from 'react';
import { Spinner } from 'react-bootstrap';

export const Loader = ({ loader }) => {
  return (
    loader ? (
      <Spinner
        style={{
          marginRight: 5,
        }}
        as='span'
        animation='border'
        size='sm'
        role='status'
        aria-hidden='true'
      />
    ):null
  );
};
